// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   SZAKJELENTÉS RÉSZLETEK (SzakjelentesDetails)
   ========================================= */

/* --- ALAP ELRENDEZÉS ÉS ŰRLAP ELEMEK --- */
.szakjelentes-create-wrapper .szakjelentes-details {
    padding: 20px;
    margin-top: 30px;
    display: flex;
}

.szakjelentes-create-wrapper .szakjelentes-details .details-container h1 {
    text-align: center;
    margin-bottom: 20px;
    margin-top: 20px;
}

.szakjelentes-create-wrapper .szakjelentes-details .details-container p {
    margin-bottom: 10px;
}

.szakjelentes-create-wrapper .szakjelentes-details .details-container input,
.szakjelentes-create-wrapper .szakjelentes-details .details-container textarea {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    box-sizing: border-box;
}

.szakjelentes-create-wrapper .szakjelentes-details .details-container textarea {
    resize: vertical;
    min-height: 100px;
}

/* --- GOMB ELRENDEZÉSEK (DETAILS OLDAL) --- */
.szakjelentes-create-wrapper .szak-button-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 15px;
    justify-content: space-between;
}

.szakjelentes-create-wrapper .szak-button-container-custom {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 10px;
    margin-bottom: 20px;
}

.szakjelentes-create-wrapper .szak-button-container-custom .szak-button-custom,
.szakjelentes-create-wrapper .szak-button-container-custom .finalize-button {
    padding: 12px 24px;
    background-color: #44ACC9 !important;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    transform: none !important;
    transition: none !important;
}

/* Hover effektek a Részletek oldalon */
.szakjelentes-create-wrapper .szak-button-container-custom .pdf-button-custom:hover:not(:disabled),
.szakjelentes-create-wrapper .szak-button-container-custom .finalize-button:hover:not(:disabled) {
    background-color: #357a9d !important;
}

/* Disabled állapotok a Részletek oldalon */
.szakjelentes-create-wrapper .szak-button-container-custom .szak-button-custom.disabled,
.szakjelentes-create-wrapper .szak-button-container-custom .szak-button-custom[disabled],
.szakjelentes-create-wrapper .szak-button-container-custom .finalize-button.disabled,
.szakjelentes-create-wrapper .szak-button-container-custom .finalize-button[disabled] {
    background-color: #ccc !important;
    color: #666 !important;
    cursor: not-allowed !important;
}

/* --- STÁTUSZ GOMB (Jobb felső sarok) --- */
.szakjelentes-create-wrapper .status-button-container {
    position: absolute;
    top: 10px;
    right: 20px;
}

.szakjelentes-create-wrapper .status-button {
    background-color: #44ACC9;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
}

.szakjelentes-create-wrapper .status-button:hover {
    background-color: #357a9d; 
}`, "",{"version":3,"sources":["webpack://./src/components/szakjelentesCreate/SzakjelentesLezaras.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C,4CAA4C;AAC5C;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,uCAAuC;AACvC;;IAEI,oCAAoC;AACxC;;AAEA,2CAA2C;AAC3C;;;;IAII,iCAAiC;IACjC,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* =========================================\n   SZAKJELENTÉS RÉSZLETEK (SzakjelentesDetails)\n   ========================================= */\n\n/* --- ALAP ELRENDEZÉS ÉS ŰRLAP ELEMEK --- */\n.szakjelentes-create-wrapper .szakjelentes-details {\n    padding: 20px;\n    margin-top: 30px;\n    display: flex;\n}\n\n.szakjelentes-create-wrapper .szakjelentes-details .details-container h1 {\n    text-align: center;\n    margin-bottom: 20px;\n    margin-top: 20px;\n}\n\n.szakjelentes-create-wrapper .szakjelentes-details .details-container p {\n    margin-bottom: 10px;\n}\n\n.szakjelentes-create-wrapper .szakjelentes-details .details-container input,\n.szakjelentes-create-wrapper .szakjelentes-details .details-container textarea {\n    width: 100%;\n    padding: 10px;\n    margin-top: 5px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 16px;\n    box-sizing: border-box;\n}\n\n.szakjelentes-create-wrapper .szakjelentes-details .details-container textarea {\n    resize: vertical;\n    min-height: 100px;\n}\n\n/* --- GOMB ELRENDEZÉSEK (DETAILS OLDAL) --- */\n.szakjelentes-create-wrapper .szak-button-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 15px;\n    justify-content: space-between;\n}\n\n.szakjelentes-create-wrapper .szak-button-container-custom {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n.szakjelentes-create-wrapper .szak-button-container-custom .szak-button-custom,\n.szakjelentes-create-wrapper .szak-button-container-custom .finalize-button {\n    padding: 12px 24px;\n    background-color: #44ACC9 !important;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    transform: none !important;\n    transition: none !important;\n}\n\n/* Hover effektek a Részletek oldalon */\n.szakjelentes-create-wrapper .szak-button-container-custom .pdf-button-custom:hover:not(:disabled),\n.szakjelentes-create-wrapper .szak-button-container-custom .finalize-button:hover:not(:disabled) {\n    background-color: #357a9d !important;\n}\n\n/* Disabled állapotok a Részletek oldalon */\n.szakjelentes-create-wrapper .szak-button-container-custom .szak-button-custom.disabled,\n.szakjelentes-create-wrapper .szak-button-container-custom .szak-button-custom[disabled],\n.szakjelentes-create-wrapper .szak-button-container-custom .finalize-button.disabled,\n.szakjelentes-create-wrapper .szak-button-container-custom .finalize-button[disabled] {\n    background-color: #ccc !important;\n    color: #666 !important;\n    cursor: not-allowed !important;\n}\n\n/* --- STÁTUSZ GOMB (Jobb felső sarok) --- */\n.szakjelentes-create-wrapper .status-button-container {\n    position: absolute;\n    top: 10px;\n    right: 20px;\n}\n\n.szakjelentes-create-wrapper .status-button {\n    background-color: #44ACC9;\n    color: white;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.szakjelentes-create-wrapper .status-button:hover {\n    background-color: #357a9d; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
